import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { disableChargingService } from '../../api/charging-service.ts';

export default function useDisableChargingService(): UseMutationResult<
  Awaited<ReturnType<typeof disableChargingService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => disableChargingService(serviceId),
  });
}
